import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId, brandSite } from '../../../sites';

import ViinimaaNavigationElements from './viinimaa';
import FolkofolkNavigationElements from './folkofolk';
import AnoraProNavigationElements from './anoraPro';

function NavigationElements(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaNavigationElements {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <FolkofolkNavigationElements {...props} />;
  }
  if (isEqual(siteId, siteIds.AnoraPro)) {
    return <AnoraProNavigationElements {...props} />;
  }
  if (brandSite) {
    return <ViinimaaNavigationElements {...props} />;
  }

  return null;
}

export default NavigationElements;
